import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../image/logo arreglado.png";
import { MdMenuOpen } from "react-icons/md";
import { FaUserGraduate, FaUserTie, FaSignOutAlt, FaBook, FaBars } from "react-icons/fa";
import { MdSubject } from "react-icons/md";
import { HiAcademicCap } from "react-icons/hi2";
import { GrScorecard, GrSchedules  } from "react-icons/gr";
import { BsCashCoin, BsCalendarEvent  } from "react-icons/bs";
import { GoHomeFill } from "react-icons/go";
import { TbCertificate } from "react-icons/tb";
import { useAuth } from "../context/AuthContext";
import { useUsers } from "../context/UsersContext"

// Menús según el rol
const menuItemsByRole = {
  1: [
    { path: "/dashboard", icon: <GoHomeFill size={26} />, label: "Inicio" },
    { path: "/estudiantes", icon: <FaUserGraduate size={26} />, label: "Estudiantes" },
    { path: "/profesores", icon: <FaUserTie size={26} />, label: "Profesores" },
    { path: "/asignaturas", icon: <MdSubject size={26} />, label: "Asignaturas" },
    { path: "/notas", icon: <GrScorecard size={26} />, label: "Notas" },
    { path: "/indicadores", icon: <FaBook size={26} />, label: "Indicadores"},
    { path: "/boletin", icon: <HiAcademicCap size={26} />, label: "Boletin"},
   
    { path: "/eventos", icon: <BsCalendarEvent size={26} />, label: "Eventos" },
    // { path: "/finanzas", icon: <BsCashCoin size={26} />, label: "Finanzas" },
    { path: "/horarios", icon: <GrSchedules size={26} />, label: "Horarios"}
    
  ],
  2: [
    { path: "/dashboard", icon: <GoHomeFill size={26} />, label: "Inicio" },
    { path: "/estudiantes", icon: <FaUserGraduate size={26} />, label: "Estudiantes" },
    { path: "/notas", icon: <GrScorecard size={24} />, label: "Notas" },
    { path: "/indicadores", icon: <FaBook size={26} />, label: "Indicadores"}, // Solo para preescolar
    { path: "/boletin", icon: <HiAcademicCap size={26} />, label: "Boletin"},
    { path: "/boletin-final", icon: <TbCertificate size={26} />, label: "Boletin Final"}, 
    { path: "/eventos", icon: <BsCalendarEvent size={26} />, label: "Eventos" },
    { path: "/horarios", icon: <GrSchedules size={26} />, label: "Horarios"}
  ],
  3: [
    { path: "/notas", icon: <GrScorecard size={26} />, label: "Notas" },
    { path: "/boletin", icon: <HiAcademicCap size={26} />, label: "Boletin"},
    { path: "/eventos", icon: <BsCalendarEvent size={26} />, label: "Eventos" },
    { path: "/horarios", icon: <GrSchedules size={26} />, label: "Horarios"}
  ],
};

export default function Sidebar() {
  const [open, setOpen] = useState(window.innerWidth > 768); // Comienza cerrado en pantallas pequeñas
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { user, logout } = useAuth();
  const { salonGrado, fetchSalonForDirector } = useUsers();
  const location = useLocation();
  
  // 🔥 NUEVO: Obtener grado del director y verificar si es preescolar
  useEffect(() => {
    if (user?.rol_id === 2 && user.director_salon) {
      fetchSalonForDirector();
    }
  }, [user, fetchSalonForDirector]);

  // ✅ PROTEGER contra null/undefined
  const grado = salonGrado?.salon_grado?.toLowerCase() || "";
  const esPreescolar = ["parvulos", "prejardin", "jardin", "transicion"].includes(grado);
  
  // Determinar los menús según el rol y permisos
  let roleMenuItems = [];

  if (user?.rol_id === 1) {
    // Admin ve todo
    roleMenuItems = menuItemsByRole[1];
  } else if (user?.rol_id === 2) {
    if (user.director_salon === null) {
      // Profesor sin salón asignado: solo ve eventos y horarios
      roleMenuItems = menuItemsByRole[2].filter(
        (item) => item.path !== "/estudiantes" && 
                 item.path !== "/notas" && 
                 item.path !== "/boletin" && 
                 item.path !== "/boletin-final" &&
                 item.path !== "/indicadores"
      );
    } else {
      // Profesor con salón asignado
      roleMenuItems = menuItemsByRole[2].filter((item) => {
        // 🔥 LÓGICA NUEVA:
        // Si es preescolar: mostrar indicadores, ocultar boletin-final
        if (esPreescolar) {
          return item.path !== "/boletin-final";
        }
        // Si NO es preescolar: mostrar boletin-final, ocultar indicadores
        else {
          return item.path !== "/indicadores";
        }
      });
    }
  } else if (user?.rol_id === 3) {
    // Estudiante ve su menú normal
    roleMenuItems = menuItemsByRole[3];
  }

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setOpen(true); // En desktop, siempre abierto
      } else {
        setOpen(false); // En móvil, cerrado por defecto
      }
    };
    
    handleResize(); // Ejecutar al montar
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Cerrar sidebar al hacer clic en un enlace (solo en móvil)
  const handleLinkClick = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  return (
    <>
      {/* Botón hamburguesa para móvil */}
      {isMobile && !open && (
        <button
          onClick={() => setOpen(!open)}
          className="fixed top-4 left-4 z-50 p-2 bg-blue-900 text-white rounded-lg shadow-lg md:hidden"
        >
          <FaBars size={20} />
        </button>
      )}

      {/* Backdrop oscuro cuando el sidebar está abierto en móvil */}
      {isMobile && open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <nav
        className={`shadow-md min-h-screen pl-2 flex flex-col duration-300 bg-blue-900 text-white
          ${isMobile ? 'fixed top-0 left-0 z-40 h-full' : 'relative'}
          ${open ? "w-60" : isMobile ? "-translate-x-full w-60" : "w-16 pl-0"}
          ${isMobile && open ? "translate-x-0" : ""}
        `}
      >
      {/* Header */}
      <div className="px-3 py-2 h-20 flex justify-between items-center">
        <img
          src={logo}
          alt="Logo"
          className={`${open ? "w-20" : "w-0"} rounded-md transition-all duration-500 overflow-hidden`}
        />
        {!isMobile && (
          <MdMenuOpen
            size={34}
            className={`duration-500 cursor-pointer ${!open && "rotate-180"}`}
            onClick={() => setOpen(!open)}
          />
        )}
      </div>

      {/* Body */}
      <ul className="flex-1 overflow-y-auto">
        {roleMenuItems.map((item, index) => (
          <li key={index} className="my-2">
            <Link
              to={item.path}
              onClick={handleLinkClick}
              className={`flex items-center gap-4 px-4 py-3 rounded-l-full transition-all duration-300 ${
                location.pathname === item.path
                  ? "bg-[#f3f4ff] text-blue-900 font-semibold shadow-md pl-6"
                  : "hover:bg-blue-600"
              }`}
            >
              <div className="flex-shrink-0">{item.icon}</div>
              <p className={`${!open && "hidden"} duration-500`}>{item.label}</p>
            </Link>
          </li>
        ))}
      </ul>

      {/* Footer con Cerrar Sesión */}
      <div className="flex flex-col gap-2 px-3 py-2 border-t border-gray-400 mt-auto items-center">
        <button
          onClick={logout}
          className={`flex items-center justify-center gap-2 p-3 mt-4 border border-white text-white rounded-full 
          hover:bg-white hover:text-blue-900 transition duration-300 
          ${open ? "w-full" : "w-12 h-12"}`}
        >
          <FaSignOutAlt size={24} />
          {open && <span className="duration-300">Cerrar Sesión</span>}
        </button>
        <div className={`${!open && "hidden"} duration-500 text-center mt-2`}>
          <p className="truncate text-xs">Desarrollado por GirGit Software</p>
          <a href="mailto:girgitdev@gmail.com" className="text-xs truncate text-gray-300">girgitdev@gmail.com</a>
        </div>
      </div>
    </nav>
    </>
  );
}